module.exports = __webpack_public_path__ + "img/523.f8f80dac.png";